import { BuildConfig } from '@common/util-models';
import { NavigationLink } from '@domgen/dgx-fe-business-models';

const headerLinks: BuildConfig['header'] = {
  home: {
    href: '/',
    label: '',
    isHidden: false,
  },
  products: {
    isHidden: false,
    label: 'Get protected',
    newWindow: false,
    routerPath: '/products',
  },
  repair: {
    href: '/RepairClaimPageView',
    isHidden: false,
    label: 'Book a repair',
    newWindow: true,
  },
  faq: {
    href: '/content/hoover-care-help-advice/hoover-faqs',
    isHidden: false,
    label: 'Help and advice',
    newWindow: true,
  },
  profile: {
    href: '/myaccount',
    icon: 'my-account',
    isHidden: false,
    label: 'My account',
  },
  myDetails: {
    routerPath: '/myaccount',
    label: 'My details',
    isHidden: true,
  },
  logout: {
    routerPath: '',
    label: 'Logout',
    isHidden: false,
  },
  myAccountHome: {
    isHidden: false,
    label: 'My plans',
    routerPath: '/myaccount',
  },
  poweredBy: {
    href: 'https://www.domesticandgeneral.com',
    label: '',
    isHidden: false,
  },
};

const privacyLink = {
  section: 'legal',
  label: 'Privacy and Cookies policy',
  href: '/privacy-cookies-policy',
  newWindow: true,
};

const protectLinks: NavigationLink[] = [
  {
    href: '/products-5/appliances-household',
    label: 'Household appliances',
    section: 'protect',
    newWindow: true,
  },
];

const usefulLinks: NavigationLink[] = [
  {
    href: '/content/hoover-care-help-advice/hoover-faqs',
    label: 'Help and advice',
    section: 'useful',
    newWindow: true,
  },
  {
    href: '/content/contact-domestic-general',
    label: 'Contact us',
    section: 'useful',
    newWindow: true,
  },
  {
    section: 'useful',
    label: 'Regulatory information',
    href: '/company-information-legal',
    newWindow: true,
  },
  {
    href: 'https://www.hoover.co.uk',
    label: 'Hoover.co.uk',
    newWindow: true,
    section: 'useful',
  },
];

const legalLinks: NavigationLink[] = [
  {
    href: '/web-terms-conditions',
    label: 'Terms of Website Use',
    section: 'legal',
    newWindow: true,
  },
  {
    href: '/privacy-cookies-policy',
    label: 'Privacy and Cookies policy',
    section: 'legal',
    newWindow: true,
  },
  {
    href: '/accessibility',
    label: 'Accessibility Policy',
    section: 'legal',
    newWindow: true,
  },
];
const socialLinks: NavigationLink[] = [];
const moreLinks: NavigationLink[] = [];
const links: NavigationLink[] = [];

const footerLinks: BuildConfig['footer'] = {
  links, // use with sales-footer (Legacy)
  protectLinks, // use with dgx-ui-wl-footer (Whitelabel)
  moreLinks, // use with dgx-ui-wl-footer (Whitelabel)
  usefulLinks, // use with dgx-ui-wl-footer (Whitelabel)
  legalLinks, // use with dgx-ui-wl-footer (Whitelabel)
  socialLinks, // use with dgx-ui-wl-footer (Whitelabel)
};

export const DEFAULT_ENVIRONMENT = {
  header: headerLinks,
  footer: footerLinks,
  links: {
    privacy: privacyLink,
  },
  dd_guarantee: 'https://www.domesticandgeneral.com/direct-debit-guarantee',
  wlClient: 'HOOVERWLUK',
  catalogueStore: 'HOOVERWLUK',
  cookieProSrc: 'https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js',
  cookieProDomainScript: 'f083b974-442c-493b-8c98-a369c1d2e868',
  action: 'QandB',
  quotePage: '/quote',
  checkoutLandingPage: '/checkout',
  checkoutOrderConfirmationPage: '/checkout/order-confirmation',
  applianceDetailsPage: '/products',
  checkoutPersonalDetailsPage: '/checkout/personal-details',
  checkoutDirectDebitPage: '/checkout/direct-debit-payment',
  checkoutCardPaymentPage: '/checkout/card-payment',
  checkoutLoggedInUserPage: '/checkout/logged-in',
  selectPaymentPage: '/checkout/select-payment',
  forgotPasswordPage: '/forgot-password',
  cms_config: {
    pagesRoot: '/dgx-sales',
    insideCmsEditor: false,
    logCmsRequests: false,
    useCachedCmsOutput: false,
    useFallbackCmsContent: false,
    cachedRouteBase: 'assets/cached-cms/pages',
    cachedContentAppBase: 'assets/cached-cms/content-apps/',
  },
  trustPilot: {
    businessUnitId: '4cb3113600006400050dfb02',
    templates: [
      {
        id: '5419b6ffb0d04a076446a9af',
        name: 'micro',
      },
      {
        id: '54ad5defc6454f065c28af8b',
        name: 'slider',
      },
    ],
  },
  cardPayment: {
    description: 'Sales',
    transactionSource: 'W',
    transactionType: 'W',
  },
  retryBackOffConfig: {
    maxRetries: 1,
    initialInterval: 3000,
    maxInterval: 3000,
  },
  postcodeServiceKey: 'ZG99-WD62-FP46-DC55',
  postcodeServiceFind:
    'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
  postcodeServiceRetrieve:
    'https://api.addressy.com/Capture/Interactive/Retrieve/v1/json3.ws',
  worldpay: {
    customisation: {
      fonts: {
        family: ['Museo Sans', 'Source Sans Pro', 'Arial'],
      },
      color: '#414141',
      buttons: {
        backgroundColor: '#038ad3',
        color: '#fff',
        border: {
          style: 'solid',
          color: '#038ad3',
          width: '5px',
          radius: '2px',
        },
        hover: {
          backgroundColor: '#0071bb',
          border: {
            color: '#0071bb',
          },
        },
      },
      inputs: {
        backgroundColor: '#ffffff',
        border: {
          style: 'solid',
          width: '1px',
          radius: '2px',
          color: '#757575',
        },
        placeholder: {
          color: '#001',
        },
        validation: {
          ok: {
            color: '#228415',
          },
          error: {
            color: '#af2c2b',
          },
        },
      },
      page: {
        backgroundColor: '#fff',
        color: '#333',
        border: {
          style: 'solid',
          color: '#ddd',
          width: '1px',
          radius: '2px',
        },
      },
    },
  },
  validLandingPages: ['/products'],
  sessionInactivityDurationInMinutes: 20,
  multiBasket: true,
  multiBasketMaximum: 10,
  redEyeTagging: false,
  appRoot: '',
  showAutoRenewalOptOut: true,
};
